import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/** Single light/dark toggle button — clicking flips between the two modes.
 * Pass `variant="marketing"` for the dark marketing header style. The
 * "system" mode is no longer offered; if it was previously selected it is
 * resolved to whatever the OS currently prefers and persisted. */
export function ThemeToggle({ variant = "default" }) {
  const { theme, setTheme } = useTheme();
  const isMarketing = variant === "marketing";

  // Resolve effective theme: system → whatever the OS reports right now.
  const effective =
    theme === "dark"
      ? "dark"
      : theme === "light"
        ? "light"
        : typeof window !== "undefined" &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light";

  const isDark = effective === "dark";
  const next = isDark ? "light" : "dark";
  const Icon = isDark ? Sun : Moon;

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
      data-theme-state={effective}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-md transition-colors ${
        isMarketing
          ? "bg-white/10 border border-white/10 text-white/75 hover:text-white hover:bg-white/15"
          : "bg-[#F1F5F9] dark:bg-white/10 border border-[#E5E7EB] dark:border-white/10 text-[#64748B] dark:text-white/65 hover:text-[#0F172A] dark:hover:text-white"
      }`}
    >
      <Icon size={15} />
    </button>
  );
}
